

















































































import { Vue, Component } from "vue-property-decorator";
import { audio } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";
import { AxiosError } from "axios";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import PlaylistTracksEditor from "@/components/forms/audio/playlist-tracks-editor.vue";
import PosterEditor from "@/components/app/images/poster-editor.vue";
import StandartModal from "@/components/app/standart-modal.vue";

const playlistUrl = audio.songs.replace("/songs", "/id3/playlists");

interface ITrack {
  _id: string;
  name: string;
  generatedName?: string;
  path?: string;
  metadata?: {
    title?: string;
    artist?: string;
    album?: string;
    duration?: number;
  };
}

interface IPlaylist {
  _id: string;
  name: string;
  show: boolean;
  description?: string;
  src?: { cover?: string };
  tracks?: ITrack[];
  createdAt: string;
  updatedAt: string;
}

@Component({
  components: {
    BSwitch,
    PlaylistTracksEditor,
    PosterEditor,
    StandartModal,
  },
})
class PlaylistDetailPage extends Vue {
  form: { name: string; description: string; show: boolean; cover: string } = {
    name: "",
    description: "",
    show: true,
    cover: "",
  };
  tracks: ITrack[] = [];
  saving = false;
  loading = false;
  playlistId = "";

  get isEdit(): boolean {
    return !!this.playlistId;
  }

  onCoverUpdate(filename: string): void {
    this.form.cover = filename;
  }

  closeModal(): void {
    this.$router.push({ name: "AudioList" });
  }

  async save(): Promise<void> {
    this.saving = true;
    const id = this.playlistId || undefined;
    const url = id ? `${playlistUrl}/${id}` : playlistUrl;
    const method = id ? "put" : "post";

    try {
      const { cover, ...rest } = this.form;
      const payload = { ...rest, src: { cover } };
      const res = await this.$axios[method](url, payload);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (!id && res.data?._id) {
          this.playlistId = res.data._id;
          this.form = {
            name: res.data.name || this.form.name,
            description: res.data.description || "",
            show: res.data.show !== undefined ? res.data.show : this.form.show,
            cover: res.data.src?.cover || this.form.cover,
          };
          this.tracks = res.data.tracks || [];
          this.$router.replace({
            name: "AudioPlaylist",
            query: { id: res.data._id },
          });
        } else {
          this.closeModal();
        }
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.saving = false;
    }
  }

  async remove(): Promise<void> {
    const id = this.playlistId;
    if (!id) return;

    const ok = await this.$bvModal.msgBoxConfirm(
      String(this.$t("music.confirmDeletePlaylist")),
      {
        title: String(this.$i18n.t("buttons.delete")),
        okVariant: "danger",
        cancelVariant: "secondary",
      }
    );
    if (!ok) return;

    deleteElement(id, playlistUrl)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.closeModal();
      })
      .catch((e: AxiosError) => {
        console.log(e);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }

  async fetchPlaylist(): Promise<void> {
    const id = this.playlistId;
    if (!id) return;

    this.loading = true;
    try {
      const res = await this.$axios.get(`${playlistUrl}/${id}`);
      if (res.status === 200) {
        const playlist: IPlaylist = res.data;
        this.form = {
          name: playlist.name,
          description: playlist.description || "",
          show: playlist.show,
          cover: playlist.src?.cover || "",
        };
        this.tracks = playlist.tracks || [];
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.loading = false;
    }
  }

  mounted(): void {
    this.playlistId = (this.$route.query.id as string) || "";
    this.fetchPlaylist();
    this.$nextTick(() => this.$bvModal.show("playlist-detail-modal"));
  }
}
export default PlaylistDetailPage;
